// ============================================================================
// view.layersHome — the Layers Home dashboard, read locally
// ============================================================================
// /layer had NO physical read of its own. Every value it rendered came from a
// provider App's boot filled: LayerContext for the two layer directories and
// for the two COMPLETE daily histories (`allLayerDailys`, `allEggDailys`, both
// published by the paginate-to-exhaustion sidecar beside loadAllDataBody), and
// FeedCostsContext for the per-lb fallback rates. `layer.home.core` owns all
// five now, which is what lets `layersHome` retire from the frozen app_store /
// layer_batches / layer_housings consumer lists in
// tests/fixtures/former-eager-dependencies.json.
//
// A sixth binding was DEAD and left without a replacement: `const {batches} =
// useBatches()` was destructured and never read. It counted as app_store
// consumption in the provenance derivation all the same, so deleting it is part
// of what makes that retirement true rather than decorative.
//
// WHY THIS IS PERMANENT AND NOT PARTIAL, GIVEN THAT useLayer IS STILL CALLED.
//
// Two bindings remain: `retHomeDashPeriod` and `setRetHomeDashPeriod`. They are
// a `useState(30)` pair declared in LayerContext and never touched by App's
// boot, by loadAllDataBody, or by any setter the boot fan-out owns — they are
// the Retirement Home card's 30/90/180 window toggle, and this view is their
// only consumer in the repo. RESIDUAL_LEGACY_IDS has no id for them precisely
// because they are not a legacy boot dependency; the four `legacy.context.layer.*`
// ids all name values the boot transaction publishes.
//
// They stay in the context rather than becoming local state because moving them
// would reset the operator's chosen window every time they navigate away from
// /layer and back. That is a behaviour change, and a localization is not
// allowed to smuggle one in. tests/static/layer_dashboard_static.test.js pins
// the destructure to exactly those two names, so a data field cannot re-enter
// through the hook that is still called here.
//
// ERROR POSTURE IS UNIFORMLY FAIL-SOFT, AND THAT IS A REPRODUCTION.
//
// This dashboard has never had an error branch, because none of its five inputs
// could ever fail loudly: layerBootLoad degrades each table to [] and logs, the
// daily sidecar's catch is documented as non-fatal, and an absent
// ppp-feed-costs-v1 row leaves FeedCostsContext at its all-zero initializer.
// layer.home.core catches each read separately for the same reason. Making any
// of them fatal would put an unhandled resource error behind a page with no UI
// to catch it — see the resource's own header.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.layersHome',
  obligations: Object.freeze([
    Object.freeze({id: 'layer.home.core', owner: 'permanent'}),
    Object.freeze({id: 'layer.eggDailys.groups', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
